/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Predictor_TitleInputs */

const en_ui_labs_predictor_title = /** @type {(inputs: Ui_Labs_Predictor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race Predictor`)
};

const de_ui_labs_predictor_title = /** @type {(inputs: Ui_Labs_Predictor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rennzeit-Prognose`)
};

/**
* | output |
* | --- |
* | "Race Predictor" |
*
* @param {Ui_Labs_Predictor_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_predictor_title = /** @type {((inputs?: Ui_Labs_Predictor_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Predictor_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_predictor_title(inputs)
	return de_ui_labs_predictor_title(inputs)
});